import { loadScript } from '@players/CoreAudioPlayer/utils';
import { TRITON_SDK } from './consts';

export const loadSdk = async (): Promise<void> => {
  const script = loadScript(TRITON_SDK);
  script.async = false;
  await new Promise((resolve, reject) => {
    script.onload = resolve;
    script.onerror = reject;
  });
};
